// Self-contained data for the Jeffie Party Shop events concept website.
export const BUSINESS = {
  "slug": "jeffie-party-shop-concept",
  "media": {
    "hero": "/events/jeffie/03.jpg",
    "logo": "/events/jeffie/17.jpg",
    "gallery": [
      "/events/jeffie/01.jpg",
      "/events/jeffie/02.jpg",
      "/events/jeffie/04.jpg",
      "/events/jeffie/05.jpg",
      "/events/jeffie/06.jpg",
      "/events/jeffie/07.jpg",
      "/events/jeffie/08.jpg",
      "/events/jeffie/09.jpg",
      "/events/jeffie/10.jpg",
      "/events/jeffie/11.jpg",
      "/events/jeffie/12.jpg",
      "/events/jeffie/13.jpg",
      "/events/jeffie/14.jpg",
      "/events/jeffie/15.jpg"
    ]
  },
  "name": "Jeffie Party Shop",
  "shortName": "Jeffie",
  "kind": "rental",
  "layout": "party-shop",
  "location": "Paco, Manila",
  "address": "1221 Pedro Gil Street, Paco, Manila, Philippines",
  "eyebrow": "Party needs in one place",
  "headline": "A simpler way to assemble the celebration.",
  "intro": "Friendly, practical browsing for party rentals, catering-related enquiries and celebration support from a long-running Manila supplier.",
  "services": [
    "Party and event rentals",
    "Catering-related services",
    "Christenings",
    "Birthdays",
    "Milestone celebrations",
    "Broader party needs"
  ],
  "proof": [
    "Public traces dating to at least 2017",
    "Unusually large review footprint",
    "Package and quotation use case"
  ],
  "reviewSnapshot": "A public directory showed 5.0/5 with 100+ reviews when checked in August 2026. Individual review text was not available.",
  "reviews": [],
  "contact": {
    "phone": "+63 949 802 8972",
    "phoneHref": "+639498028972",
    "email": "jeffyprintingshop@yahoo.com",
    "facebook": "https://www.facebook.com/596523840456067"
  },
  "sources": [
    "https://www.bizippines.com/jeffie-party-shop-0949-802-8972",
    "https://www.facebook.com/596523840456067",
    "https://www.whodoyou.com/biz/1506261/jeffie-party-shop-manila-ncr"
  ]
};
